var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentReadyToFillOpt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 5.4c-.4.4-.8.6-1.4.6-.5 0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4 0-.6.2-1 .6-1.4.4-.4.9-.6 1.4-.6.6 0 1 .2 1.4.6.4.4.6.8.6 1.4 0 .5-.2 1-.6 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 7.7c.2.2.3.4.4.7l2.8 7.9-1.9.7-1.4-3.9L14 22h-4L8.4 9.5 5.2 4.9l1.6-1.1L9.1 7h4.6c.6 0 1.1.2 1.6.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentReadyToFillOpt2);
export default __webpack_public_path__ + "c69381b434dfb59ad63a62f2043be01b.svg";
export { ForwardRef as ReactComponent };